module.exports = __webpack_public_path__ + "img/features_side_image.7f0078a9.jpg";